import { render, staticRenderFns } from "./PurchaseAndSalePdf.vue?vue&type=template&id=24c1eea6&scoped=true"
import script from "./PurchaseAndSalePdf.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSalePdf.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSalePdf.vue?vue&type=style&index=0&id=24c1eea6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1eea6",
  null
  
)

export default component.exports